export interface IProductionRequest {
  igsCustomerNumber: string;
  dateFrom: Date;
  dateTo: Date;
}

export class ProductionRequest implements IProductionRequest {
  igsCustomerNumber: string;
  dateFrom: Date;
  dateTo: Date;
}